import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const FlagImage = styled.img`
  max-width: 196px;
  margin: 0 auto;
  height: auto;
  object-fit: cover;
  transition: all ease-out 0.25s;
  cursor: pointer;
`;

const FlagSection = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  margin-top: 20px;
`;
const BoldText = styled.p`
  max-width: 70%;
  margin: 0 auto;
  font-size: 16px;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  line-height: 1.1;
  color: ${COLORS.BODY_TEXT};
`;
const Text = styled.p`
  max-width: 70%;
  margin: 0 auto;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  color: ${COLORS.BODY_TEXT};
`;

const Flag = styled.div`
  background-color: ${(props) => (props?.selected ? '#ccc' : 'none')};
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  p {
    margin: 0;
    font-weight: bold;
  }

  :hover {
    background-color: #ccc;
  }
`;

export { FlagImage, FlagSection, BoldText, Text, Flag };
